import { DictionaryContext, DictionaryText, RichText, Text, TextTypes } from '@lib-components'
import PagePanel from '../layout/PagePanel'
import { use, useEffect, useState, ReactElement } from 'react'
import { ConfigContext } from '@/providers/config-provider'

const MESSAGE_KEYS = {
    TITLE: 'STO.CHECK.TITLE',
    SUB_TITLE: 'STO.CHECK.SUB_TITLE',
    HEADER_TEXT: 'STO.CHECK.HEADER_TEXT',
    GREETING: 'STO.CHECK.GREETING',
    INTRO_PART_1: 'STO.CHECK.INTRO_PART_1',
    INTRO_PART_2: 'STO.CHECK.INTRO_PART_2',
}

const RegistrationCheckFormHeader = (): ReactElement => {
    const { envVariables } = use(ConfigContext)
    const { getText } = use(DictionaryContext)
    const [introText, setIntroText] = useState<string>()

    useEffect(() => {
        const AEEAUrl = envVariables?.NEXT_PUBLIC_AEEA_URL
        const epacURL = envVariables?.NEXT_PUBLIC_EPAC_BINDING_STATEMENT_URL
        const stopenURL = envVariables?.NEXT_PUBLIC_BATTERIES_BINDING_STATEMENT_URL

        if (AEEAUrl && epacURL && stopenURL)
            setIntroText(
                getText(MESSAGE_KEYS.INTRO_PART_2, {
                    AEEAUrl,
                    stopenURL,
                    epacURL,
                }),
            )
    }, [])

    return (
        <header>
            <PagePanel className="pb-3 pt-0">
                <Text className="mb-2" type={TextTypes.HEADING_4}>
                    <DictionaryText textKey={MESSAGE_KEYS.GREETING} />
                </Text>
                {introText && (
                    <div className="mb-4">
                        {/* The umbraco 'value' field only goes up to 500 characters. That is why the message is split over two keys. */}
                        <DictionaryText textKey={MESSAGE_KEYS.INTRO_PART_1} />{' '}
                        <RichText rawHtml={introText} className="inline" />
                    </div>
                )}

                <div className="flex justify-between items-start">
                    <div>
                        <Text type={TextTypes.HEADING_6} className="text-accent-700 mb-4">
                            <DictionaryText textKey={MESSAGE_KEYS.HEADER_TEXT} />
                        </Text>
                        <Text type={TextTypes.HEADING_2} className="mb-2">
                            <DictionaryText textKey={MESSAGE_KEYS.TITLE} />
                        </Text>
                        <Text type={TextTypes.SMALL_TEXT}>
                            <DictionaryText textKey={MESSAGE_KEYS.SUB_TITLE} />
                        </Text>
                    </div>
                </div>
            </PagePanel>
        </header>
    )
}

export default RegistrationCheckFormHeader
